import React from 'react';
import './PageTitle.css';

const PageTitle: React.FC<{ title: string; actions?: React.ReactNode }> = ({ title, actions }) => (
  <div className="page-title">
    <h1>{title}</h1>
    {actions && <div className="page-title__actions" data-tour="page-actions">{actions}</div>}
  </div>
);

export default PageTitle;
